import React, {Fragment} from "react";
import ChannelCard from "../../Utilities/ChannelCard";
import logoFreshdesk from "../../../../../images/logos/logo_freshdesk.svg";
import {useSelector} from "react-redux";
import useFreshdeskSetup from "./useFreshdeskSetup";
import FreshdeskSetupModal from "./FreshdeskSetupModal";
import DataSourceWebhookModal from "../../Utilities/DataSourceWebhookModal";

export default function FreshdeskProvider() {
    const freshdesk = useSelector((state) => state.freshdeskAuth)
    const { initiateFreshdeskSetup, freshdeskSetupOpen, handleFreshdeskSetupOpen, handleFreshdeskSetupClose } = useFreshdeskSetup()

    return(
        <Fragment>
            <ChannelCard
                icon={logoFreshdesk}
                label={'Freshdesk'}
                description={'Resolve support tickets and clear your backlog'}
                onClick={initiateFreshdeskSetup}
            />

            <FreshdeskSetupModal
                open={freshdeskSetupOpen}
                handleOpen={handleFreshdeskSetupOpen}
                handleClose={handleFreshdeskSetupClose}
            />

            <DataSourceWebhookModal
                showWebhookUrl={freshdesk?.showWebhookUrl}
                webhookUrl={freshdesk?.data?.webhookUrl}
                platformUrl={freshdesk?.data?.platformUrl}
                dataSourceName={'Freshdesk'}
            />
        </Fragment>
    )
}